import { render, staticRenderFns } from "./OverviewRequirements.vue?vue&type=template&id=3699d0f6&scoped=true"
import script from "./OverviewRequirements.vue?vue&type=script&lang=js"
export * from "./OverviewRequirements.vue?vue&type=script&lang=js"
import style0 from "./OverviewRequirements.vue?vue&type=style&index=0&id=3699d0f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3699d0f6",
  null
  
)

export default component.exports